import React, { useEffect, useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import imgurl from "../assets/images/imgurl";
import moment from "moment";
import axios from "axios";
import { setGlobalFilter } from "../Redux/actions/globalFilterActions";
import { useSelector, connect } from "react-redux";
import Nav from "react-bootstrap/Nav";
import { setActiveService } from "../Redux/actions/activeService";

const mapDispatchToProps = (dispatch) => ({
  setGlobalFilter: (user) => dispatch(setGlobalFilter(user)),
  setActiveService: (user) => dispatch(setActiveService(user)),
});

function Header({ setGlobalFilter, setActiveService }) {
  const [show, setShow] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // county  option states
  const [countyOption, setCountyOption] = useState([]);
  const [selectedCoOption, setSelectedCoOption] = useState(null);
  const [countyId, setCountyId] = useState([]);
  // sub county option states
  const [subCountyOption, setsubCountyOption] = useState([]);
  const [selectedsubOption, setSelectedsubOption] = useState(null);
  const [subcountyId, setsubCountyId] = useState([]);
  // cases options states
  const [caseCatOptions, setcaseCatOptions] = useState([]);
  const [selectedCatOption, setSelectedCatOption] = useState(null);
  const [globalDateFilter, setGlobalDateFilter] = useState({
    label: "Yearly",
    value: "YEARLY",
  });
  const [quarterSelect, setQuarterSelect] = useState({});
  const [activeId, setActiveId] = useState(1);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navHeadings = useSelector((state) => state.serviceIndicator);
  useEffect(() => {
    getCountyOptionData();
    getCategoryCaseData();
  }, []);

  useEffect(() => {
    if (selectedCoOption !== null) {
      getSubCountyOptionData();
    }
  }, [selectedCoOption]);

  const getCountyOptionData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getCountyOptions`,
        data
      );
      let response = res.data.data;
      let countyOptinArr = [];
      Object.keys(response.optionMap).forEach((value) => {
        countyOptinArr = [
          ...countyOptinArr,
          {
            value: value,
            label: response.optionMap[value],
          },
        ];
      });

      setCountyOption(countyOptinArr);
      setCountyId(response.questionIds);
    } catch (error) {
      console.log(error);
    }
  };

  const getSubCountyOptionData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      questionIds: countyId,
      selectedOptions: [selectedCoOption.value],
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getSubCountyOptions`,
        data
      );
      let response = res.data.data;
      let subCountyArr = [];
      Object.keys(response.optionMap).forEach((value) => {
        subCountyArr = [
          ...subCountyArr,
          {
            value: value,
            label: response.optionMap[value],
          },
        ];
      });
      setsubCountyOption(subCountyArr);
      setsubCountyId(response.subQuestionIds);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryCaseData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      languageId: 1,
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/getInvolved/getServiceByCommunityId`,
        data
      );
      let response = res.data.data;
      let casesArr = [];
      response.forEach((value) => {
        casesArr = [
          ...casesArr,
          {
            value: value.id,
            label: value.name,
          },
        ];
      });
      setcaseCatOptions(casesArr);
    } catch (error) {
      console.log(error);
    }
  };

  const navHeadingsSequence = [
    // this array is written to be used as the sequence order in which the headings are rendered
    "Commodities",
    "Treatment literacy",
    "Human Rights",
    "Support Groups",
    "Service delivery",
  ];

  const updateTabSection = (serviceId) => {
    setActiveService(serviceId);
    setActiveId(serviceId);
  };

  return (
    <div className="openDashboard-section">
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container fluid>
          <Navbar.Brand href="">
            <img src={imgurl.mainlogo} className="mx-3 main-logo" alt="logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto navsection">
              <Nav.Link href="" className="main-center">
                <p className="mb-0 heading-div">iMonitor+ ATM KENYA</p>
              </Nav.Link>
              <Nav.Link
                className={`${activeId === 1 ? "active" : ""}`}
                onClick={() => updateTabSection(1)}
              >
                Overview
              </Nav.Link>
              {/* Overview is kept static */}
              {/* here the headings are dynamically displayed, the headings are obtained from the redux store */}
              {/* here we sort the headings as per the requested order , the sequence of headings is given in an array above 'navHeadingsSequence'  */}
              {navHeadings
                .sort((a, b) => {
                  const indexA = navHeadingsSequence.indexOf(a.serviceName);
                  const indexB = navHeadingsSequence.indexOf(b.serviceName);

                  return indexA - indexB;
                })
                .map((heading) => {
                  return (
                    <Nav.Link
                      onClick={() => updateTabSection(heading.serviceId)}
                      className={`${
                        heading.serviceId === activeId ? "active" : ""
                      }`}
                    >
                      {heading.serviceName}
                    </Nav.Link>
                  );
                })}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(Header);
